var flextabs = require('flextabs');

var targets = document.querySelectorAll('.flextabs');
for (var i = 0; i < targets.length; i += 1) {
  var tabs = flextabs(targets[i]);
  tabs.init();
}
